import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Card } from '../card';
import { CardFeed } from '../cardFeed/CardFeed';

// Interface

export interface CardsProps {
  components: CardsItemProps[];
  display?:
    | 'Grid - 2 columns'
    | 'Grid - 3 columns'
    | 'Grid - 4 columns'
    | 'carousel';
  cardBackground?: 'Background' | 'no background';
}

export interface CardsItemProps {
  image: string;
  heading?: string;
  url?: string;
  label?: string;
  description?: string;
  tag?: string;
}

type StyledCardsProps = Pick<CardsProps, 'display'>;

// Styles

const StyledGrid = styled.div<StyledCardsProps>`
  ${({ theme: { space, media }, display, tight }) => {
    let columns: string;
    switch (display) {
      case 'Grid - 2 columns':
        columns = '2';
        break;
      case 'Grid - 3 columns':
        columns = '3';
        break;
      case 'Grid - 4 columns':
        columns = '4';
        break;
      default:
        columns = '4';
    }
    return css`
      display: grid;
      gap: ${space.medium};
      ${columns === '2' &&
      css`
        .gatsby-image-wrapper-constrained {
          width: 100%;
        }
      `}
      @media (min-width: ${media.medium}) {
        grid-template-columns: repeat(2, 1fr);

        ${tight &&
        css`
          gap: ${space.xSmall};
        `}
      }
      @media (min-width: ${media.large}) {
        grid-template-columns: ${`repeat(${columns}, 1fr)`};
      }
    `;
  }};
`;

// JSX

export const CardRenderer: FC<CardsItemProps> = ({
  page,
  tag,
  heading,
  image,
  description,
  link,
  cardConfig,
  tickListItems,
  ...rest
}) => {
  let cardHeading;
  let cardDescription;
  let cardTag;
  let cardUrl;
  let cardLabel;
  let cardImage;
  let cardFeature;
  let cardBackground;
  let cardList;

  // linkContent {
  //   properties {
  //     feed {
  //       shortTitle
  //       shortDescription

  if (page) {
    cardHeading = page.linkContent?.properties?.feed?.shortTitle
      ? page.linkContent?.properties?.feed?.shortTitle
      : page.linkName;
    cardDescription = page.linkContent?.properties?.feed?.shortDescription;
    cardTag = undefined;
    cardUrl = page.url;
    cardLabel = page.linkName ? page.linkName : 'Find out more';
    cardImage =
      page.linkContent?.properties?.feed?.featuredImage?.image?.localFile;
  } else {
    cardHeading = heading;
    cardDescription = description;
    cardTag = tag;
    cardUrl = link?.url;
    cardLabel = link?.label;
    cardImage = image?.image?.localFile;
    cardList = tickListItems;
  }

  if (!image?.image?.localFile && image?.image?.src) {
    console.log('image', image);
  }

  return (
    <Card
      heading={cardHeading}
      description={cardDescription}
      tag={cardTag}
      url={cardUrl}
      label={cardLabel}
      image={cardImage}
      background={cardBackground}
      list={cardList}
      {...cardConfig}
      {...rest}
    />
  );
};

export const Cards: FC<CardsProps> = ({
  components,
  display = 'Grid - 4 columns',
  cardBackground = 'background',
  ...rest
}) => {
  if (!components || components?.length <= 0) {
    return null;
  }

  const cardConfig = {
    feature: false,
    background: cardBackground === 'Background' ? 'white' : 'none',
  };

  return (
    <StyledGrid
      display={display}
      {...rest}
      tight={cardBackground === 'Background'}
    >
      {components.length >= 1 &&
        components.map((component, index) => (
          <CardRenderer {...component} cardConfig={cardConfig} key={index} />
        ))}
    </StyledGrid>
  );
};

export default Cards;
